"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddToOtherNodesDialog = void 0;
const react_1 = __importStar(require("react"));
const actions_with_other_nodes_dialog_1 = require("./partials/actions-with-other-nodes-dialog");
const product_tree_nodes_1 = require("../../../client/product-tree-nodes");
const hooks_1 = require("../../../hooks");
const localization_1 = require("../../../../localization");
const localization_utils_1 = require("../../../../localization/localization.utils");
const AddToOtherNodesDialog = ({ onClose, onSubmit, attributes, isLoading, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const selectedProductTreeNode = (0, hooks_1.useSelectedTreeNode)();
    const handleSubmit = (selectedNodePaths) => onSubmit(selectedNodePaths);
    const productTreeNodeFilter = (0, react_1.useMemo)(() => {
        const attributeValuesMap = attributes.reduce((acc, { name }) => (Object.assign(Object.assign({}, acc), { [name]: [] })), {});
        return (0, product_tree_nodes_1.buildFilterToExcludeAttributes)(attributeValuesMap);
    }, [attributes]);
    return (react_1.default.createElement(actions_with_other_nodes_dialog_1.ActionsWithOtherNodesDialog, { productTreeNodeFilter: productTreeNodeFilter, title: t({ key: 'DIALOG_ADD_TO_OTHER_NODES', values: { entity: String(t({ key: 'ATTRIBUTE' })).toLowerCase() } }), successSingleActionCompleteTitle: t({
            key: 'ADD_ENTITY_SUCCESS',
            values: {
                count: attributes.length,
                entity: String(t({ key: 'ATTRIBUTE' })).toLowerCase(),
                entityName: attributes.map(({ name }) => name).join(', '),
                nodeName: selectedProductTreeNode === null || selectedProductTreeNode === void 0 ? void 0 : selectedProductTreeNode.title,
                b: localization_utils_1.renderBoldText,
            },
        }), onSubmit: handleSubmit, onClose: onClose, isLoading: isLoading }));
};
exports.AddToOtherNodesDialog = AddToOtherNodesDialog;
exports.default = exports.AddToOtherNodesDialog;
